import { Alert, Collapse, Stack } from "@mui/material";
import type { WorkflowSignalType } from "@entrilia/shared/api/workflowTypes";
import { workflowSignalTypeMap } from "../../../utilities/enumCaptions";
import ActionChecksAlert from "./ActionChecksAlert";

interface Props {
  action: WorkflowSignalType;
  blockers: string[];
  warnings: string[];
  hasFailed: boolean;
  hint?: string;
}

const WorkflowActionChecks = ({ action, blockers, warnings, hasFailed, hint }: Props) => {
  if (hasFailed) {
    return (
      <Collapse appear in sx={{ width: "100%" }}>
        <Alert severity="info" sx={{ textAlign: "left" }}>
          We couldn&apos;t check for blockers.
        </Alert>
      </Collapse>
    );
  }

  if (blockers.length === 0 && warnings.length === 0) {
    return null;
  }

  const actionCaption = workflowSignalTypeMap.get(action)?.caption ?? action;

  return (
    <Stack spacing={1} sx={{ width: "100%" }}>
      {blockers.length > 0 && (
        <ActionChecksAlert
          title={`Can't ${actionCaption.toLowerCase()} yet`}
          groups={[{ id: "blockers", messages: blockers }]}
          hint={hint}
        />
      )}
      {warnings.length > 0 && (
        <ActionChecksAlert severity="warning" groups={[{ id: "warnings", messages: warnings }]} />
      )}
    </Stack>
  );
};

export default WorkflowActionChecks;
